interface ICharacterLimitRequest {
  name: string;
  ticketAutomationMacroId: string;
  characterLimit: string;
}

const calcTotalCaracters = (
  bodyText: string,
  characterLimitRequests?: ICharacterLimitRequest[],
) => {
  const cleanedText = bodyText ? bodyText.replace(/{{[^}]+}}/g, "") : "";

  const list = Array.isArray(characterLimitRequests)
    ? characterLimitRequests
    : [];
  const totalCharacterLimitRequests = list.reduce((acc: number, curr: any) => {
    const raw = `${curr?.characterLimit ?? ""}`.trim();
    const val = parseInt(raw || "0", 10);
    const safeVal = isNaN(val) ? 0 : val;
    const plus3 = safeVal > 0 ? 3 : 0;
    return acc + safeVal + plus3;
  }, 0);

  const totalCharacters = cleanedText.length + totalCharacterLimitRequests;

  return totalCharacters;
};

export const useBodyField = () => {
  return { calcTotalCaracters };
};
